module.exports = __webpack_public_path__ + "img/Logo-23.5ef48dea.svg";